import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavLink, useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { PageLayout, BasicModal, DefaultButton } from 'common/components';
import { withTheme } from 'common/styling/theme';

import noPartnersImage from 'common/images/noPartners.svg';

import { toggleCreateIssueModal } from 'client/support/_redux';
import { requestPartnership, requestEasyStart } from '../../_redux';
import IssueForm from '../../../_components/IssueForm';

import { staticStyles, getDynamicStyles } from './style';
import ChooseProgramModalContent from '../../_components/ChooseProgramModalContent/ChooseProgramModalContent';

const PartnershipPage = ({
  profile,
  requestPartnership,
  requestEasyStart,
  createIssueModalIsOpen,
  toggleCreateIssueModal,
  partnership,
  partnershipTemplate,
  requestEasyStartState,
  requestEasyStartIsSending,
  isFriendProgramActive,
  theme,
}) => {
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;
  const [isLoading, setLoading] = useState(false);
  const [isChooseProgramOpen, setIsChooseProgramOpen] = useState(false);
  const history = useHistory();
  const partnershipFormInitialValues = { description: partnershipTemplate };

  const handleBecomePartner = () => {
    setIsChooseProgramOpen(false);
    if (!partnership.verification) {
      requestEasyStart({ referType: 'refer_partner' });
    } else {
      toggleCreateIssueModal();
    }
  };

  const handleChooseProgram = () => {
    if (isFriendProgramActive) {
      setIsChooseProgramOpen(true);
    } else {
      handleBecomePartner();
    }
  };

  const handleChooseReferFriend = () => {
    setIsChooseProgramOpen(false);
    history.push('/referFriend');
  };

  useEffect(() => {
    setLoading(requestEasyStartIsSending);

    if (requestEasyStartState === 'refer_partner') {
      history.push('/');
    }
  }, [requestEasyStartState, requestEasyStartIsSending, history]);

  return (
    <PageLayout captionSlug="menuPartnership">
      <div className="PartnershipPage">
        <div className="PartnershipPage__top-inner">
          <img src={noPartnersImage} alt="Partner" />

          <FormattedMessage id="partnershipPanelCaption">{txt => <h3>{txt}</h3>}</FormattedMessage>

          <FormattedMessage id="partnershipConditionsAfterApplication">{txt => <p>{txt}</p>}</FormattedMessage>
        </div>

        {profile.isReferPartnerRequested || requestEasyStartIsSending ? (
          <div className="PartnershipPage__inner">
            <FormattedMessage id="partnershipPanelRequestText">{txt => <p>{txt}</p>}</FormattedMessage>

            <NavLink to="support">
              <FormattedMessage id="partnershipPanelRequestLink" />
            </NavLink>
          </div>
        ) : (
          <div className="PartnershipPage__button-inner">
            <DefaultButton
              type="button"
              onClick={handleChooseProgram}
              textId="partnershipPanelButtonText"
              filled
              loading={isLoading}
            />
          </div>
        )}

        <BasicModal
          isOpen={isChooseProgramOpen}
          captionId="partnerProgramIsThisRightForYou"
          onRequestClose={() => setIsChooseProgramOpen(false)}>
          <ChooseProgramModalContent
            onBecomePartner={handleBecomePartner}
            onChooseReferFriend={handleChooseReferFriend}
          />
        </BasicModal>

        {partnership.verification && (
          <BasicModal
            isOpen={createIssueModalIsOpen}
            captionId="createIssueModalHeader"
            onRequestClose={toggleCreateIssueModal}>
            <IssueForm
              partnershipRequest="refer_partner"
              partnership={partnership}
              onSubmitFunc={requestPartnership}
              initialValues={partnershipFormInitialValues}
            />
          </BasicModal>
        )}

        <style jsx>{staticStyles}</style>
        <style jsx>{dynamicStyles}</style>
      </div>
    </PageLayout>
  );
};

PartnershipPage.propTypes = {
  profile: PropTypes.object.isRequired,
  createIssueModalIsOpen: PropTypes.bool.isRequired,
  toggleCreateIssueModal: PropTypes.func.isRequired,
  requestPartnership: PropTypes.func.isRequired,
  requestEasyStart: PropTypes.func.isRequired,
  partnership: PropTypes.object.isRequired,
  partnershipTemplate: PropTypes.string.isRequired,
  requestEasyStartState: PropTypes.string.isRequired,
  requestEasyStartIsSending: PropTypes.bool.isRequired,
  theme: PropTypes.object,
  isFriendProgramActive: PropTypes.bool.isRequired,
};

PartnershipPage.defaultProps = {
  theme: {},
};

const ThemedPartnershipPage = withTheme()(PartnershipPage);

export default connect(
  state => ({
    profile: state.user.profile,
    createIssueModalIsOpen: state.client.support.createIssueModalIsOpen,
    partnership: state.interfaceConfig.partnership,
    partnershipTemplate: state.interfaceConfig.partnership.partnershipTemplate
      .replace(/(<([^>]+)>)/gi, '')
      .replace('&amp;', '&'),
    requestEasyStartState: state.client.partnership.requestEasyStart,
    requestEasyStartIsSending: state.client.partnership.requestEasyStartIsSending,
    isFriendProgramActive: state.interfaceConfig.partnership?.refer_friend,
  }),
  {
    requestPartnership: () => requestPartnership.request({ referType: 'refer_partner' }),
    requestEasyStart: params => requestEasyStart.request(params),
    toggleCreateIssueModal: () => toggleCreateIssueModal(),
  }
)(ThemedPartnershipPage);
export { PartnershipPage };
